var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showFooter)?_c('v-footer',[_c('v-container',{staticClass:"text-center"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }